module["exports"] = [
  "Hr.",
  "Fr.",
  "Dr."
];
